<template>
	<div class="Developers">

		<card class="dev-table col-sm-12">
			<el-table :data="tableData">
				<el-table-column
					min-width="130"
					sortable
					label="Застройщик"
				>							
					<template v-slot="scope">
						{{$GVO.GetCat('CAT_DEV',scope.row.dc_dev_name_tr).name}}
					</template>
				</el-table-column>
				<el-table-column
					min-width="110"								
					label="Комиссия от %"
				>
					<template v-slot="scope">
						<base-input
						placeholder="Комиссия от %"
						v-model="scope.row.min_commission"
						autocomplete="off"
						type="number"
						class="mt-2"
						></base-input>
					</template>
				</el-table-column>
				<el-table-column
					min-width="110"								
					label="Комиссия до %"
				>
					<template v-slot="scope">
						<base-input
						placeholder="Комиссия до %"
						v-model="scope.row.max_commission"
						autocomplete="off"
						type="number"
						class="mt-2"
						></base-input>
					</template>
				</el-table-column>
				<el-table-column
					min-width="130"					
					label="Реклама"
					class="pt-0"
				>
					<template v-slot="scope">
						<el-select
							class="col-md px-0 select-primary"						
							filterable
							placeholder="Да, нет, с ограничениями"
							v-model="scope.row.ads"
							size="large"
						>
							<el-option
								class="select-primary"
								v-for="option in masAdds.options"
								:key="option.label"
								:label="option.label"
								:value="option.value"
							>
							</el-option>
						</el-select>
					</template>
				</el-table-column>
				<el-table-column
					min-width="200"					
					min-height="150"					
					label="Ограничения"
					class="pt-0"													
				>	
					<template v-slot="scope">
						<div class="type-search">
							<el-select
								:disabled="scope.row.ads != 2"
								class="col-md px-0 select-primary  overflow-overlay"						
								filterable
								placeholder="Ограничения"
								multiple
								v-model="scope.row.restriction_ids"
								size="large"
							>
								<el-option
									class="select-primary long-select"
									v-for="option in masRestrictions.options"
									:key="option.label"
									:label="option.label"
									:value="option.value"
								>
								</el-option>
							</el-select>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<div v-if="successMsg" class="success-msg"><h6>Данные успешно сохранены!</h6></div>
			<div class="bottom_part mt-2">
				<base-button type="success" simple @click="Save()">Сохранить</base-button>										
			</div>
		</card>
	</div>
</template>

<script>
/*
	застройщики - получаем тех по кому я ответсвенный в кураторах
	ограничения появляются только когда "РЕКЛАМА с ограничениями"
	ОГРАНИЧЕНИЯ - мультиселект из спавочника ограничения
*/
	import { Table, TableColumn } from 'element-ui';
	import { Select, Option } from 'element-ui';
	

	export default {
		name: 'developers-page',
		components: {
			[Table.name]: Table,
			[TableColumn.name]: TableColumn,
			[Option.name]: Option,
			[Select.name]: Select,
		},
		props: {
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			value: Object,
		}, 
		
		data() {
			return {
				tableData: [],
				masAdds: {
					options: [
						{value: '0',label: 'Да',},
						{value: '1',label: 'Нет',},
						{value: '2',label: 'С ограничениями',},
					],
				},
				masRestrictions: {
					options: [],
				},
				successMsg: false,
				isLong: true,

			}
		},
		methods: {
			PrepareTableData(){
				for (let i = 0; i < this.tableData.length; i++) {
					if(this.tableData[i].min_commission == -1) this.tableData[i].min_commission = '';
					if(this.tableData[i].max_commission == -1) this.tableData[i].max_commission = '';
					if(this.tableData[i].ads == -1) this.tableData[i].ads = '';
					//if(this.tableData[i].restriction_ids !== '') this.tableData[i].restriction_ids = this.tableData[i].restriction_ids.split(',');
					if(this.tableData[i].restriction_ids > '') this.tableData[i].restriction_ids = String(this.tableData[i].restriction_ids).split(',');
					
					/*
					if(this.tableData[i].external_fio == -1) this.tableData[i].external_fio = '';
					if(this.tableData[i].phone == -1) this.tableData[i].phone = '';
					this.tableData[i].telegram=this.tableData[i].telegram==1?true:false;
					this.tableData[i].whatsapp=this.tableData[i].whatsapp==1?true:false;
					if(this.tableData[i].email == -1) this.tableData[i].email = '';
					if(this.tableData[i].site == -1) this.tableData[i].site = '';
					if(this.tableData[i].agregator_id == -1) this.tableData[i].agregator_id = '';
					*/
				}
			},
			GetData(){
				this.$GVO.ApiCall('GetMyDevExtraData',{obj:'DEV' ,flt:{}})
				.then((objApi) => {
					if(objApi.success === true){
						this.$GVO.LoadCatPromise('CAT_DEV',true).then((bCatLoaded) => {
							this.$GVO.LoadCatPromise('CAT_AD_RESTRICTIONS',true).then((bCatLoaded) => {
								this.masRestrictions.options = this.$GVO.getCatToSelect('CAT_AD_RESTRICTIONS');
								this.tableData = objApi.data;
								this.PrepareTableData();
							}).catch(errorObjApi => {console.error(errorObjApi);});
						}).catch(errorObjApi => {console.error(errorObjApi);});
					}
				}).catch(errorObjApi => {console.error(errorObjApi);});
			},
			Save(){
				for (let i = 0; i < this.tableData.length; i++) {
					this.tableData[i].restriction_names = [];
					if(this.tableData[i].min_commission == '') this.tableData[i].min_commission = null;
					if(this.tableData[i].max_commission == '') this.tableData[i].max_commission = null;
					if(this.tableData[i].restriction_ids != null){
						for (let y = 0; y < this.tableData[i].restriction_ids.length; y++) {
							const element = this.tableData[i].restriction_ids[y];
							for (let z = 0; z < this.masRestrictions.options.length; z++) {
								const ro = this.masRestrictions.options[z];
								if(ro.value == element){
									this.tableData[i].restriction_names.push(ro.label);
								}
							}
						}
					}
					/*
					if(this.tableData[i].external_fio == '') this.tableData[i].external_fio = null;
					if(this.tableData[i].phone == '') this.tableData[i].phone = null;
					this.tableData[i].telegram=this.tableData[i].telegram==true?1:0;
					this.tableData[i].whatsapp=this.tableData[i].whatsapp==true?1:0;
					if(this.tableData[i].email == '') this.tableData[i].email = null;
					if(this.tableData[i].site == '') this.tableData[i].site = null;
					*/
					
				}
				//console.log(this.tableData);
				this.$GVO.ApiCall('UpdMyDevExtraData',{obj:'DEV' ,flt:{},uData:{masAllData:this.tableData}})
				.then((objApi) => {
					if(objApi.success === true){
						this.successMsg = true;
					}else{
						alert('Не сохранилось');
					}
				}).catch(errorObjApi => {console.error(errorObjApi);});
			}
		},
		mounted() {
			this.GetData();
		}
	};
</script>

<style scoped>
.dev-table >>>.el-table__row td {margin-top: 0px;}
/*============================ SEND NOTES ========================================*/
.postAddForm-hide {
	display: none;
} 
.postAddForm-show {
	display: block;
	margin-top: 15px;
}
.postForm {
	border: 1px solid transparent;
	border: 1px solid #01B0E0;
	border-radius: 0.2857rem;
	position: sticky;
	bottom: 0;		
}
.postForClick {cursor: pointer;}
.postForm >>> .card-body {padding: 0px 5px 15px 10px!important;}
.cancel-note-btn {position: absolute;  top: 0; right: 0;}
.clientPage .card-collapse .postForm {
	background: #27293d;
}
.white-content .card:not(.card-white) .postForm {
	background: #fff;
}
.postForm:hover, .focus-shadow  {
	box-shadow: 0px 0px 10px rgba(1, 176, 224, 0.3);
}
.postForm h5 {
	margin-bottom: 0px;
}
.form-container {display: flex; flex-direction: column; justify-content: space-between; padding: 0px 5px;}
.postForm .bottom_part, .top_part  {display: flex; flex-wrap: wrap; justify-content: space-between;}
.postForm .bottom_part button, .fileinput {margin: 10px 10px 0px 0px;}

.postAddForm >>> .nav-pills .nav-item i {line-height: 30px;}
.postAddForm >>> .nav-pills .nav-item .nav-link {padding: 7px 20px; min-width: 80px;}
.postAddForm >>> .tab-space {padding: 20px 0 10px 0px;}
.upload-file {display: flex; align-items: center;}
.upload-file h5 {margin-bottom: 0px; margin-right: 10px;}

.note-btn-group {position: relative;}
.note-btn-row {position: absolute; top: 5px; right: 0;}
.Developers >>> .el-table table > thead > tr > th {vertical-align: top;}




.success-msg {
	display: flex; justify-content: center;
	opacity: 0;
	animation: success-msg 3s;
  	animation-delay: 0.5s;
}
.success-msg  h6 {color: #00BF9A !important;}

@keyframes success-msg {
  from {opacity: 0;}
  to {opacity: 100%;}
}

/*===media===============================*/
@media (max-width: 768px) {	
	
}

</style>
